import { render, staticRenderFns } from "./Bill.vue?vue&type=template&id=51cea2ca&scoped=true&"
import script from "./bill-list.js?vue&type=script&lang=js&"
export * from "./bill-list.js?vue&type=script&lang=js&"
import style0 from "./bill-list.scss?vue&type=style&index=0&id=51cea2ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cea2ca",
  null
  
)

export default component.exports